(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gripz-complete-kit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('grz-complete-kit')) return;
    customElements.define('grz-complete-kit', class extends HTMLElement {
      connectedCallback() {
        if (!this.querySelector('[data-add-button]') || !this.querySelector('template[data-sizes]')) {
          this.childObserver?.disconnect();
          this.childObserver = new MutationObserver(() => {
            if (this.querySelector('[data-add-button]') && this.querySelector('template[data-sizes]')) {
              this.childObserver.disconnect();
              this.connectedCallback();
            }
          });
          this.childObserver.observe(this, { childList: true, subtree: true });
          return;
        }
        if (this.listenerController) return;
        this.listenerController = new AbortController();
        const signal = this.listenerController.signal;
        this.size = this.querySelector('[data-size-select]');
        this.button = this.querySelector('[data-add-button]');
        this.status = this.querySelector('[data-status]');
        this.review = this.querySelector('[data-review-cart]');
        const currentGlove = Array.from(this.querySelectorAll('[data-glove-choice]')).find(choice => choice.value === this.dataset.currentProduct);
        if (currentGlove) currentGlove.checked = true;
        this.addEventListener('change', event => {
          if (event.target.matches('[data-glove-choice]')) this.populateSizes();
          this.updateSelection();
        }, { signal });
        this.button.addEventListener('click', () => this.addBoth(), { signal });
        this.populateSizes();
        this.updateSelection();
      }
      disconnectedCallback() {
        this.childObserver?.disconnect();
        this.listenerController?.abort();
        this.listenerController = null;
      }
      populateSizes() {
        const previousSize = this.size.selectedOptions[0]?.textContent;
        const glove = this.querySelector('[data-glove-choice]:checked');
        const template = Array.from(this.querySelectorAll('template[data-sizes]')).find(item => item.dataset.sizes === glove?.value);
        this.size.replaceChildren(...(template ? Array.from(template.content.children).map(option => option.cloneNode(true)) : []));
        if (previousSize) {
          const matchingSize = Array.from(this.size.options).find(option => option.textContent === previousSize);
          this.size.selectedIndex = matchingSize ? matchingSize.index : 0;
        }
      }
      updateSelection() {
        const size = this.size.selectedOptions[0];
        const band = this.querySelector('[data-band-choice]:checked');
        this.querySelector('[data-glove-price]').textContent = size?.dataset.price || '';
        this.querySelector('.grz-kit__prices [data-total]').textContent = size?.dataset.total || '';
        this.querySelector('.grz-kit__prices [data-compare]').textContent = size?.dataset.compare || '';
        this.button.disabled = Boolean(this.requestInFlight) || !size || !band;
        if (!this.requestInFlight) this.button.textContent = this.dataset.addLabel.replace('__PRICE__', size?.dataset.total || '');
      }
      async addBoth() {
        const band = this.querySelector('[data-band-choice]:checked');
        if (this.requestInFlight || !this.size.value || !band?.value) return;
        const gloveId = Number(this.size.value);
        const bandId = Number(band.value);
        if (!Number.isSafeInteger(gloveId) || !Number.isSafeInteger(bandId)) return;
        const properties = { _gripz_offer: 'complete-kit-oct14' };
        const items = [{ id: gloveId, quantity: 1, properties }, { id: bandId, quantity: 1, properties }];
        this.requestInFlight = true;
        this.setAttribute('aria-busy', 'true');
        this.querySelectorAll('input, select').forEach(control => { control.disabled = true; });
        this.button.disabled = true;
        this.button.textContent = this.dataset.adding;
        this.status.textContent = '';
        this.review.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items })
          });
          if (!response.ok) {
            const result = await response.json().catch(() => ({}));
            const description = typeof result.description === 'string' ? result.description : '';
            this.status.textContent = response.status === 422 ? `${description} ${this.dataset.incomplete}`.trim() : this.dataset.unconfirmed;
            this.review.hidden = false;
            return;
          }
          this.status.textContent = this.dataset.added;
          window.location.assign(this.dataset.cartUrl);
          this.navigatingToCart = true;
        } catch (error) {
          this.status.textContent = this.dataset.connectionError;
          this.review.hidden = false;
        } finally {
          if (!this.navigatingToCart) {
            this.requestInFlight = false;
            this.removeAttribute('aria-busy');
            this.querySelectorAll('input, select').forEach(control => { control.disabled = false; });
            this.updateSelection();
          }
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
